import { ResolvedComponentsConfiguration } from "@zoovu/runner-browser-api";
import stylesConfig from "../styles.config";

const sliderBackground = stylesConfig.colors.secondary.spectrum100;
const sliderSelectedBackground = stylesConfig.colors.primaryAccentColorVariants.default;
export default {
  container: {
    position: "relative",
    userSelect: "none",
    zIndex: 2,
    "& .slider": {
      height: "5px !important",
      position: "relative",
      display: "block",
      background: sliderBackground,
      "&::after": {
        content: "''",
        position: "absolute",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        zIndex: 2,
      },
    },
    "& .slider-selected-range": {
      position: "absolute",
      display: "block",
      background: sliderSelectedBackground,
      zIndex: 1,
      transition: "background 0s",
    },
    "&.slider-horizontal .slider-selected-range": {
      width: 0,
      height: "100%",
      top: 0,
      left: 0,
      willChange: "width",
    },
    "& .slider-dot": {
      position: "absolute",
      border: "2px solid white",
      borderRadius: "50%",
      background: stylesConfig.colors.primary.spectrum700,
      left: 0,
      willChange: "transform",
      transition: "all 0s",
      cursor: "pointer",
      zIndex: 5,
      width: "30px !important",
      height: "30px !important",
      top: "-13px !important",
      "&.slider-dot-focus": {
        boxShadow: (configuration: ResolvedComponentsConfiguration): string =>
          `0 0 2px 1px ${sliderSelectedBackground(configuration)}`,
      },
      "&.slider-dot-dragging": {
        zIndex: 5,
      },
    },
    "&.slider-horizontal .slider-dot": {
      left: 0,
    },
    "&.slider-vertical .slider-dot": {
      bottom: 0,
    },
  },
};
